import { settingsConstants } from '../_constants';
import * as commonAction from './commonAction';
import { commonService } from '../_services';
import { alertActions } from './';
import { history } from '../_helpers';
import { apiConstants } from '../_constants/api.constants';


export const settingsActions = {
    getGeneralSettings,
    updateGeneralSettings
};


//-- Get user detail on profile page
function getGeneralSettings(apiName,settingData) {
    return dispatch => {
        dispatch(commonAction.request(settingsConstants.C_SETTINGS_REQUEST));       
        commonService.getDataWithToken(apiName, settingData)
            .then(
                user => {
                    dispatch(commonAction.success(settingsConstants.C_SETTINGS_SUCCESS, user.data));
                    if (user.success == false) {
                        dispatch(commonAction.failure(settingsConstants.C_SETTINGS_FAILURE, user.message));
                        dispatch(alertActions.error(user.message));
                    } 
                },
                error => {
                    dispatch(alertActions.error(error.response.data.error));
                }
            );
    };
}

//-- update detail on general setting page
function updateGeneralSettings(apiName, settingData ,getApi,postData) {
    return dispatch => {
        dispatch(commonAction.request(settingsConstants.C_SETTINGS_REQUEST, settingData));
        commonService.withTokenPut(apiName, settingData)
            .then(
                user => {
                    dispatch(commonAction.success(settingsConstants.C_SETTINGS_SUCCESS, user));
                    dispatch(alertActions.success("general setting updated"));
                    setTimeout(function () {
                        dispatch(alertActions.clear())
                    }, 3000);

                    dispatch(getGeneralSettings(getApi,postData))
                },
                error => {
                    dispatch(alertActions.error(error.response.data.error));
                }
            );
    };
}